<div class="text-input-wrapper">
  <div class="input-wrapper" [ngClass]="errorState && showErrorBorder?'text-error':''">
    <mat-form-field class="displayFlex" appearance="outline" *ngIf="!multiline" [ngClass]="styleApplied === 'editable-table' ? 'input-form-field-height-32' : 'input-form-field'"
    >
      <!-- matAutocompletDisabled="false" -->
      <!-- [autocomplete]="autoCompleteValue" -->
      <input
      matInput
      type="{{type || 'text'}}"
      class="input"
      [placeholder]=" placeholder ? placeholder :  'Type here'"
      [(ngModel)]="value"
      (change)="onInputChange($event)"
      (keyup)="onInputChange($event)"
      [disabled]="(formControl && formControl.disabled) || etsMandate"
      autocomplete="off"
      (keypress)="checkInput($event,elementKey)"
      (paste)="validateInput($event)"
      />
     <img *ngIf="showCross" class="cross-icon" src="assets/cross.svg" alt=""
     (click)="clearFormCallback.emit(true)"
     >
    </mat-form-field>
    <div class="error-msg error-state" [ngClass]="errorMsgNoWrap ? 'noWrap' : ''" *ngIf="showError()"><img src="assets/error-16.svg" alt="" class="error-icon">{{getErrorMessage(formControl)}}</div>

    <textarea
    
      *ngIf="multiline"
      class="text-area comment-area"
      placeholder="Type here"
      [ngClass]="{'input-error': showError()}"
      [(ngModel)]="value"
      (change)="onInputChange($event)"
      (keyup)="onInputChange($event)"
      [disabled]="formControl && formControl.disabled"
      [width]="'650px'"
    >
    </textarea>
  </div>
</div>
